import React from "react";
import ReactGA from "react-ga";
import styles from "./intro.module.scss";
import { useIsMobile } from "../../hooks/mobile.js";
import { ICON_EMAIL } from "../../config/constants";

ReactGA.initialize("UA-11963560-5");

export default function Intro(props) {
    const isMobile = useIsMobile();
    const [expanded, setExpanded] = React.useState(false);

    const handleExpand = () => {
        setExpanded(!expanded);
        ReactGA.event({
            category: "SCIKNOW: intro",
            action: "expand",
            label: expanded ? "false" : "true",
        });
    };

    const handleContact = () => {
        ReactGA.event({
            category: "SCIKNOW: intro",
            action: "contact",
        });
    };

    return (
        <div className={styles.intro}>
            <p>
                Welcome to the interactive version of our{" "}
                <a
                    href="https://www.gbrmpa.gov.au/our-work/reef-strategies/science-for-management"
                    title="Science for management"
                >
                    Science and Knowledge Needs for Management.
                </a>
            </p>
            {isMobile && (
                <button className={styles.introExpando} onClick={() => handleExpand()}>
                    {expanded ? "Less " : "More "} information about the tool
                </button>
            )}
            {(!isMobile || expanded) && (
                <p className={styles.introExpanded}>
                    The Great Barrier Reef Marine Park Authority uses high quality science and deploys innovative
                    solutions to deliver world-leading management of the Great Barrier Reef. Our management actions must
                    be optimised to ensure they lead to desired future outcomes. This is why our priority science and
                    knowledge needs have a focus on elements that will help improve our management and protection
                    strategies over the long term. These priority needs will form the focus of collaboration
                    opportunities with science and knowledge providers and guide what we support. The priorities have
                    been informed by the Great Barrier Reef Outlook Report 2019, the Reef 2050 Plan and emerging needs
                    identified by the Authority.
                    <br />
                    <br />
                    Here, you can explore the four overarching themes and their sub-themes, which describe program-level
                    priority questions which may require greater level of effort and collaboration to answer. You can
                    also search for discrete project-level research questions suitable for post-graduate student
                    projects. Active research projects currently in progress are not listed here.
                </p>
            )}
            <button
                className={styles.contactButton}
                onClick={() => {
                    window.location.href = "mailTo:science@gbrmpa.gov.au";
                    handleContact();
                }}
            >
                <span className={styles.contactEmailIcon}>{ICON_EMAIL}</span>Contact our science team for more
                information
            </button>
        </div>
    );
}
